import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { radiusTokens } from '@/theme/themePrimitives';

/** Campaign chips, summary, indicators and the chart while the results load. */
const ResultsSkeleton = () => (
  <Stack gap={3} aria-busy="true">
    <Stack direction="row" gap={1}>
      <Skeleton
        variant="rounded"
        width={180}
        height={32}
        sx={{ borderRadius: radiusTokens.pill }}
      />
      <Skeleton
        variant="rounded"
        width={160}
        height={32}
        sx={{ borderRadius: radiusTokens.pill }}
      />
    </Stack>
    <Skeleton variant="rounded" height={88} />
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' },
      }}
    >
      {Array.from({ length: 5 }, (_, index) => (
        <Skeleton key={index} variant="rounded" height={96} />
      ))}
    </Box>
    <Skeleton variant="rounded" height={220} />
  </Stack>
);

export default ResultsSkeleton;
